import { useEffect, useRef, useState } from 'react';
import { useStateInRef } from 'seagull/utils/useStateInRef';
import { useIoContext, useStore } from '~/contexts';
const resolvedWithin = (settled, timeoutMs)=>new Promise((resolve)=>{
        const timer = setTimeout(resolve, timeoutMs);
        void settled.catch(()=>{}).then(()=>{
            clearTimeout(timer);
            resolve();
        });
    });
export function useNativeSplashOverlay(param) {
    let { fadeOutMs, hideSafetyMs } = param;
    const { native } = useIoContext();
    const authFlowDone = useStore((state)=>state.authFlowDone);
    const [phase, setPhase] = useState('looping');
    const [animationData, setAnimationData] = useState(null);
    const hasHidden = useRef(false);
    const getHideNativeSplashAfterFirstLaunchUpdate = useStateInRef(hideNativeSplashAfterFirstLaunchUpdate);
    useEffect(()=>{
        let active = true;
        void import('../anchor-splash.json').then((module)=>{
            if (active) setAnimationData(module.default);
        }).catch(()=>{});
        return ()=>{
            active = false;
        };
    }, []);
    useEffect(()=>{
        const timer = setTimeout(hideNativeSplash, hideSafetyMs);
        return ()=>clearTimeout(timer);
    }, [
        hideSafetyMs
    ]);
    useEffect(()=>{
        let fadeTimer;
        let active = true;
        if (authFlowDone) {
            void getHideNativeSplashAfterFirstLaunchUpdate()().then(()=>{
                if (active) {
                    setPhase('fading');
                    fadeTimer = setTimeout(()=>setPhase('done'), fadeOutMs);
                }
            }).catch(()=>{});
        }
        return ()=>{
            active = false;
            clearTimeout(fadeTimer);
        };
    }, [
        authFlowDone,
        fadeOutMs
    ]);
    function hideNativeSplash() {
        if (hasHidden.current) return;
        hasHidden.current = true;
        void native.splashScreen.hide().catch(()=>{});
    }
    // WHY: a first-launch OTA reloads the WebView — hiding early shows the shipped bundle mid-swap.
    async function hideNativeSplashAfterFirstLaunchUpdate() {
        await resolvedWithin(native.ota.whenFirstLaunchUpdateSettled(), hideSafetyMs);
        hideNativeSplash();
    }
    const onFirstFramePainted = ()=>void hideNativeSplashAfterFirstLaunchUpdate().catch(()=>{});
    return {
        phase,
        animationData,
        onFirstFramePainted
    };
}
